<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <div class="relative bg-white" v-bind="$attrs">
    <div class="px-4">
      <slot></slot>
    </div>
  </div>
</template>
